var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 27.9998C4.66699 17.0004 4.66699 11.5007 8.08408 8.08359C11.5012 4.6665 17.0009 4.6665 28.0003 4.6665C38.9998 4.6665 44.4995 4.6665 47.9166 8.08359C51.3337 11.5007 51.3337 17.0004 51.3337 27.9998C51.3337 38.9993 51.3337 44.499 47.9166 47.9161C44.4995 51.3332 38.9998 51.3332 28.0003 51.3332C17.0009 51.3332 11.5012 51.3332 8.08408 47.9161C4.66699 44.499 4.66699 38.9993 4.66699 27.9998Z",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 20.7085C23.625 18.2923 25.5838 16.3335 28 16.3335C30.4162 16.3335 32.375 18.2923 32.375 20.7085C32.375 22.3125 31.5118 23.715 30.2245 24.4765C29.1154 25.1327 28 26.1282 28 27.4168V30.3335",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0003,
    cy: 37.3333,
    r: 2.33333,
    fill: "#AEBEF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2d1b20d2e2bc5ac69e335d3ef321143f.svg";
export { ForwardRef as ReactComponent };